import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import { translate } from "../../utils/utils";

import {
  SET_RISKS,
  SELECT_RISK,
  ADD_RISK,
  UPDATE_RISK,
  REMOVE_RISK,
} from "../types/risksTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const setRisks = (items, totalPages, sources) => ({
  type: SET_RISKS,
  payload: { items, totalPages, sources },
});
export const selectedRisk = (item) => ({ type: SELECT_RISK, payload: item });
export const addRisk = (item) => ({ type: ADD_RISK, payload: item });
export const updateRisk = (id, data) => ({
  type: UPDATE_RISK,
  payload: { id: id, data },
});
export const removeRisk = (id) => ({ type: REMOVE_RISK, payload: id });

export const fetchAllRisks = (page, searchText, filter) => {
  return async (dispatch) => {
    dispatch(requestStarted("risk"));
    try {
      const res = await axiosInstance.get(
        `/model/risks?page=${page}&search${
          searchText ? "=" + searchText : ""
        }&source${filter !== "all" ? "=" + filter : ""}`
      );
      const items = res.data;
      dispatch(setRisks(items?.risks, items?.total_pages, items?.sources));
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchSelectedRisk = (id) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(`/model/risks/${id}`);
      const item = res.data;
      dispatch(selectedRisk(item));
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestCreatingRisk = (
  page,
  searchText,
  filter,
  { riskName, riskDescription },
  accountId,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    const data = {
      [translate("title")]: riskName,
      [translate("description")]: riskDescription,
      assets: [],
      weaknesses: [],
    };
    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }
    try {
      const res = await axiosInstance.post(`/model/risks`, data);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        addRisk({
          [translate("title")]: riskName,
          [translate("description")]: riskDescription,
          assets: [],
          weaknesses: [],
        })
      );
      dispatch(fetchAllRisks(page, searchText, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestUpdatingRisk = (
  page,
  searchText,
  filter,
  id,
  { riskName, riskDescription },
  accountId,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    const data = {
      [translate("title")]: riskName,
      [translate("description")]: riskDescription,
    };
    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }

    try {
      const res = await axiosInstance.put(`model/risks/${id}`, data);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        updateRisk(id, {
          [translate("title")]: riskName,
          [translate("description")]: riskDescription,
        })
      );
      dispatch(fetchAllRisks(page, searchText, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeletingRisk = (
  page,
  searchText,
  filter,
  id,
  accountType,
  accountId
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.delete(
              `model/risks/${id}?related_account_id=${accountId}`
            )
          : await axiosInstance.delete(`model/risks/${id}`);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(removeRisk(id));
      dispatch(fetchAllRisks(page, searchText, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeleteRiskAsset = (
  id_asset,
  risk,
  accountType,
  accountId
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    let updatedAssets = risk.assets.filter((asset) => asset !== id_asset);
    let data = {
      title: risk.title,
      description: risk.description,
      weaknesses: risk.weaknesses,
      assets: updatedAssets,
    };
    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }
    try {
      const res = await axiosInstance.put(`model/risks/${risk.id}`, data);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        updateRisk(risk.id, {
          title: risk.title,
          description: risk.description,
          weaknesses: risk.weaknesses,
          assets: updatedAssets,
        })
      );
      dispatch(fetchSelectedRisk(risk.id));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeleteRiskWeakness = (
  id_weakness,
  risk,
  accountType,
  accountId
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    let updatedWeaknesses = risk.weaknesses.filter(
      (weakness) => weakness !== id_weakness
    );

    let data = {
      title: risk.title,
      description: risk.description,
      weaknesses: updatedWeaknesses,
      assets: risk.assets,
    };

    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }
    try {
      const res = await axiosInstance.put(`model/risks/${risk.id}`, data);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        updateRisk(risk.id, {
          title: risk.title,
          description: risk.description,
          weaknesses: updatedWeaknesses,
          assets: risk.assets,
        })
      );
      dispatch(fetchSelectedRisk(risk.id));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAddRiskAssets = (
  id,
  title,
  description,
  assets,
  weaknesses,
  accountId,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    const data = {
      [translate("title")]: title,
      [translate("description")]: description,
      weaknesses: weaknesses ? weaknesses : [],
      assets: assets,
    };
    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }
    try {
      const res = await axiosInstance.put(`model/risks/${id}`, data);
      dispatch(requestSucceeded());
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        updateRisk(id, {
          [translate("title")]: title,
          [translate("description")]: description,
          weaknesses: weaknesses ? weaknesses : [],
          assets: assets,
        })
      );
      dispatch(fetchSelectedRisk(id));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAddRiskWeaknesses = (
  id,
  title,
  description,
  assets,
  weaknesses,
  accountId,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    const data = {
      [translate("title")]: title,
      [translate("description")]: description,
      weaknesses: weaknesses,
      assets: assets ? assets : [],
    };
    if (accountType === "enterprise") {
      data.related_account_id = accountId;
    }
    try {
      const res = await axiosInstance.put(`model/risks/${id}`, data);
      dispatch(requestSucceeded());
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        updateRisk(id, {
          [translate("title")]: title,
          [translate("description")]: description,
          weaknesses: weaknesses,
          assets: assets ? assets : [],
        })
      );
      dispatch(fetchSelectedRisk(id));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
